import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { DcEventHistoryEntry } from '../../domain/dc-schedule.model';
import { DcRosterService } from '../../services/dc-roster.service';
import { getHttpErrorMessage } from '../../shared/http-error-message.util';

export interface ScheduleEventHistoryDialogData {
  eventId: string;
  code: string;
}

@Component({
  selector: 'app-schedule-event-history-dialog',
  templateUrl: './schedule-event-history-dialog.component.html',
  styleUrls: ['./schedule-event-history-dialog.component.css']
})
export class ScheduleEventHistoryDialogComponent implements OnInit {
  loading = true;
  errorMessage = '';
  entries: DcEventHistoryEntry[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: ScheduleEventHistoryDialogData,
    private dcRosterService: DcRosterService
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      const response = await firstValueFrom(
        this.dcRosterService.getScheduleEventHistory(this.data.eventId)
      );
      this.entries = response.entries ?? [];
    } catch (error) {
      this.errorMessage =
        'Could not load event history: ' + (await getHttpErrorMessage(error));
    } finally {
      this.loading = false;
    }
  }

  actorLabel(entry: DcEventHistoryEntry): string {
    return entry.changedByName || entry.changedByAuthId || 'Unknown user';
  }

  collectorLabel(name: string | null, auth0Id: string | null): string {
    return name || auth0Id || 'Unassigned';
  }

  statusLabel(status: string | null): string {
    return status || '—';
  }
}
